/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForReservedInstance extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForReservedInstance");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForReservedInstance.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForReservedInstance>): BackgroundJobPayloadForReservedInstance {
        let obj = Object.assign(new BackgroundJobPayloadForReservedInstance(), model);
        BackgroundJobPayloadForReservedInstance.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForReservedInstance>): BackgroundJobPayloadForReservedInstance {
        if (!model) return null;
        return BackgroundJobPayloadForReservedInstance.newInstance(<BackgroundJobPayloadForReservedInstance> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForReservedInstance) {
        if (!obj) return;

        models.BackgroundJobPayloadForReservedInstance.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForReservedInstance): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForReservedInstance.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    sync_recommendation: boolean;

    sync_utilization: boolean;

}
